import React from "react"
import { Button as PaperButton } from "react-native-paper"
import { StyleSheet } from "react-native"
import { baseColors, basePadding, dimensions } from "@Constants/baseStyles"

export const Button = (props) => {
    return (
        <PaperButton
            loading={props.loading}
            disabled={(props.disabled && props.disabled == true) || props.loading}
            onPress={props.onPress}
            contentStyle={{ height: props.height ?? 40 }}
            theme={{ roundness: props.roundness || 2 }}
            labelStyle={{
                ...styles.label,
                color: props.labelColor,
                fontSize: props.fontSize || 12
            }}
            mode={props.mode || "contained"}
            style={{
                ...props.style,
                borderColor: props.borderColor || props.backgroundColor,
                alignSelf: "center",
                marginTop: props.marginTop != undefined ? props.marginTop : 20,
                marginBottom: props.marginBottom ?? undefined,
                marginVertical: props.marginVertical ?? undefined,
                width: props.width ?? dimensions.fullWidth - basePadding.paddingHorizontal * 2,
                borderWidth: props.borderWidth || 0,
                backgroundColor: props.disabled && props.disabled == true ? baseColors.grey : props.backgroundColor
            }}
        >
            {props.text}
        </PaperButton>
    )
}

const styles = StyleSheet.create({
    label: {
        justifyContent: "center",
        alignContent: "center",
        textTransform: "uppercase"
    }
})

export const ButtonGreenDark = {
    text: "Suivant",
    width: "80%",
    onPress: () => {},
    height: 50,
    backgroundColor: baseColors.green.primary,
    labelColor: baseColors.white
}

export const CardButtonGreenDark = {
    text: "Suivant",
    width: "80%",
    onPress: () => {},
    backgroundColor: baseColors.green.primary,
    labelColor: baseColors.white
}

export const ButtonGreenLight = {
    text: "Suivant",
    width: "80%",
    onPress: () => {},
    height: 50,
    backgroundColor: baseColors.green.light,
    labelColor: baseColors.green.dark
}
